export default "__VITE_ASSET__17993b1f__"